import { useContext } from "react";
import { StoreContext } from "../store/Store";
import { config } from "../d3charts/vecviz/config";

export const Tooltip = () => {
  const [store] = useContext(StoreContext);
  const { dimensions, tooltip } = store;

  const tconfig = config.tooltips;

  const lineStyle = {
    height: tconfig.lineHeight,
    margin: 5,
    backgroundColor: tooltip.stroke,
  };

  const orient = tooltip.position.x > dimensions.vw / 2 ? "left" : "right";
  const style = {
    display: "flex",
    position: "absolute",
    top: tooltip.position.y + tconfig.offset,
    left: orient === "right" ? tooltip.position.x + tconfig.offset : undefined,
    right:
      orient === "left"
        ? dimensions.vw - tooltip.position.x + tconfig.offset
        : undefined,
    backgroundColor: tconfig.box.fill,
    borderRadius: tconfig.box.radius,
    color: tconfig.text.color,
    fontSize: tconfig.text.fontSize,
    fontWeight: tconfig.text.fontWeight,
    border: `${tconfig.box.strokeWidth}px solid ${tconfig.box.stroke}`,
    zIndex: 999999,
    padding: 10,
    pointerEvents: "none",
    marginRight: orient === "right" ? 40 : undefined,
    marginLeft: orient === "left" ? 40 : undefined,
    maxWidth: "40%",
  };

  const labelStyle = { whiteSpace: "nowrap" };
  return tooltip.active ? (
    <div style={style}>
      <table>
        <tbody>
          {Object.entries(tooltip.content).map((item, i) => {
            return (
              <tr key={i}>
                <td style={labelStyle}>{item[0]}</td>
                <td>:</td>
                <td>{item[1]}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <div style={lineStyle}></div>
    </div>
  ) : null;
};
